import React, { Suspense, useMemo } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Downline from "../pages/Downline";
import Login from "../pages/Login";
import Meeting from "../pages/Meeting";
import NewMeeting from "../pages/NewMeeting";
import Profile from "../pages/Profile";
import Register from "../pages/Register";
import Report from "../pages/Report";
import ResetPassword from "../pages/ResetPassword";
import Withdrawal from "../pages/Withdrawal";

function RoutesCore() {
  const path = useLocation();

  const AllRoutes = useMemo(() => React.lazy(() => import("./index")), []);

  return (
    <Suspense fallback={<>Loading ...</>}>
      <AllRoutes path={path}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/new-meeting" element={<NewMeeting />} />
          <Route path="/meeting" element={<Meeting />} />
          <Route path="/downline" element={<Downline />} />
          <Route path="/incentive-report" element={<Report />} />
          <Route path="/withdrawal" element={<Withdrawal />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
      </AllRoutes>
    </Suspense>
  );
}

export default RoutesCore;
